export default {
  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
